import store from "../store";
import {HIDE_ERROR_EVENT, HIDE_SNACKBAR_EVENT, NOTIFY_ERROR_EVENT, NOTIFY_SNACKBAR_EVENT} from "./notifyActionTypes";

export function showError(error) {
    return store.dispatch({
        type: NOTIFY_ERROR_EVENT,
        payload: error
    })
}

/**
 * @param {Response} response - Response from promise
 */
export async function getPromiseErrorText(response) {
    if (response.status / 100 !== 5) {
        const json = await response.json();
        if (json && json.message) {
            return json.message;
        }
    }
    return "Operation cannot be completed. See the log for details";

}

export function hideError() {
    store.dispatch({
        type: HIDE_ERROR_EVENT
    })
}

export function hideSnackbar() {
    store.dispatch({
        type: HIDE_SNACKBAR_EVENT
    })
}

export function showSnackbar(message, properties) {
    store.dispatch({
        type: NOTIFY_SNACKBAR_EVENT,
        payload: {
            message: message,
            properties: properties
        }
    })
}


